var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Department',{attrs:{"value":_vm.dep,"options":{
    depType: 2,
  },"person":false},on:{"update:value":function($event){_vm.dep=$event}}})}
var staticRenderFns = []

export { render, staticRenderFns }